<template>
  <h3 v-bind="$attrs"><slot /></h3>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BmSubpageHeading",
});
</script>

<style scoped lang="sass">
@import "src/sass/colours"
@import "src/sass/typography"

h3
  @include bm-subtitle
  color: $bm-color-brand01
  margin-top: 1em
  margin-bottom: 1em
</style>
